import { NETWORK } from "./appDataVariables";
import store from "../rootReducer";

export function setNetwork(network) {
  store.dispatch({ type: NETWORK, network });
}
